import btoa from 'btoa';

// SAP Basic Authentication credetials format
export const getBase64Credentials = (user, password) => btoa(`${user}:${password}`);

